import { atom } from "jotai";
import { showZslFeedbackAtom } from "./showZslFeedbackAtom";

export const dismissFeedbackFormSetter = atom(null, (_get, set) => {
  set(showZslFeedbackAtom, false);
});

dismissFeedbackFormSetter.debugLabel = "dismissFeedbackFormSetter";
